/*
  Окно «Позвонить выбранным» - разбор и подтверждение обзвона (вариант Б,
  решение владельца 06.10.2026).

  Разбор берётся из строк таблицы: отметку «обзвон наберёт» и причину отказа
  по каждой посчитал сервер тем же правилом, что и запуск. Повторять здесь
  правило «ночь - не отказ, а ожидание» значило бы держать его второй копией.
  Запуск проверяет всё заново, и его ответ - счётчики настоящего обзвона -
  карточка хода показывает сразу после закрытия окна.

  Звонок - внешнее действие, которое не отменить, поэтому кнопка называет число
  звонков, а пропущенные перечислены до нажатия, а не после.
*/

import { useState } from 'react'
import { Link } from 'react-router-dom'

import { api } from '../api/client.js'
import { dateTime } from '../api/format.js'
import { Notice, Tag } from './Common.jsx'
import Modal from './Modal.jsx'
import PageBar from './PageBar.jsx'
import usePaging from './usePaging.js'

export default function CallWaveDialog({ chosen, list, onClose, onStarted }) {
  const [state, setState] = useState({ busy: false, error: null })
  const ready = chosen.filter((row) => row.can_call)
  const refused = chosen.filter((row) => !row.can_call)
  // 21.10.2026: пропускаемых при большой волне сотни - общая панель страниц под списком.
  const { rows: refusedRows, bar: refusedBar } = usePaging(refused)
  const blocked = list?.channel_blocked

  async function start() {
    setState({ busy: true, error: null })
    try {
      const wave = await api.startCallWave(chosen.map((row) => row.account_id))
      onStarted(wave)
    } catch (error) {
      setState({ busy: false, error })
    }
  }

  return (
    <Modal title={`Позвонить выбранным: ${chosen.length}`} onClose={onClose} busy={state.busy}>
      <div className="stack">
        {blocked ? (
          <Notice kind="warn">
            <div className="notice__what">Звонить нечем.</div>
            <div className="notice__do">{blocked}</div>
          </Notice>
        ) : (
          <div className="row">
            <Tag kind="calm">позвоним: {ready.length}</Tag>
            <Tag kind="muted">пропустим: {refused.length}</Tag>
          </div>
        )}

        {!blocked && list?.resume_at ? (
          <div className="muted">
            Сейчас вне разрешённых часов: первый звонок - {dateTime(list.resume_at)} по вашему
            времени.
          </div>
        ) : null}

        {refused.length ? (
          <details>
            <summary className="muted">Кого пропустим и почему</summary>
            <div className="log">
              {refusedRows.map((row) => (
                <div className="log__row" key={row.account_id}>
                  <Link className="log__when" to={`/accounts/${row.account_id}`}>
                    счёт {row.number}
                  </Link>
                  <span>{row.refusal}</span>
                </div>
              ))}
            </div>
            <PageBar {...refusedBar} what="счетов" />
          </details>
        ) : null}

        <div className="muted">
          Звонит голосовой агент от имени вашей организации, по одному звонку: следующий номер
          набирается после окончания разговора. Перед каждым звонком правила проверяются заново;
          ночью обзвон замрёт и сам продолжит утром.
        </div>

        <Notice error={state.error} />
        <div className="row">
          {!blocked && ready.length ? (
            <button type="button" className="button" disabled={state.busy} onClick={start}>
              {state.busy ? 'Запускаем…' : `Запустить обзвон: ${ready.length}`}
            </button>
          ) : null}
          <button type="button" className="button button--quiet" onClick={onClose}>
            {!blocked && ready.length ? 'Отмена' : 'Закрыть'}
          </button>
        </div>
      </div>
    </Modal>
  )
}
